import axios from "axios";
import { endpoints } from "Views/Tags/api/endpoints";

export const endpoint = "/api/categories";

export const getCategory = (id) => axios.get(`${endpoint}/${id}`);

export const removeCategory = (id) => axios.delete(`${endpoint}/${id}`);

export const getCategoriesList = () => axios.get(`${endpoint}/list`);

export const searchCategories = (query = "", page = 1, perPage = 20) =>
  axios.get(`${endpoint}`, {
    params: {
      search: query,
      page,
      perPage,
    },
  });

export const searchSystemCategories = (query = "", page = 1, perPage = 20) =>
  axios.get(`${endpoint}/system`, {
    params: {
      search: query,
      page,
      perPage,
    },
  });

export const getCategoriesListByRegisterToken = (token) => {
  return axios.get(`${endpoint}/list/${token}`);
};

export const getRegisterSubtags = (tagId, token) =>
  axios.get(
    `${endpoint}/${tagId}/areas-of-interest/browser-to-register/${token}`
  );

export const createCategory = (form) => axios.post(`${endpoint}`, form);

export const updateCategory = (form, id) =>
  axios.post(`${endpoint}/${id}`, form);

export const createSubcategory = (payload, categoryId) => {
  return axios.post(endpoints.createSubtag(categoryId), payload);
};

export const updateSubcategory = (payload, categoryId, subcategoryId) =>
  axios.post(endpoints.updateSubtag(categoryId, subcategoryId), payload);

export const getCategoryAois = (categoryId) =>
  axios.get(`${endpoint}/${categoryId}/areas-of-interest/browser`);

export const disableTag = (tagId) => axios.post(`${endpoint}/${tagId}/disable`);

export const enableTag = (tagId) => axios.post(`${endpoint}/${tagId}/enable`);

export const getAllTagSubtags = (categoryId) =>
  axios.get(`${endpoint}/${categoryId}/areas-of-interest/browser-all`);
